import React from 'react';
import './ScheduleView.css';
import { getIsoCodeByCountryId } from '../../utils/countryUtils';
import { FlagIcon } from '../FlagIcon/FlagIcon';

export interface TeamParticipant {
  teamName: string;
  countryId: number;
}

interface TeamSportLayoutProps {
  participantOne: TeamParticipant;
  participantTwo: TeamParticipant;
  children: React.ReactNode;
}

export const TeamSportLayout: React.FC<TeamSportLayoutProps> = ({
  participantOne,
  participantTwo,
  children,
}) => {
  const isParticipantOneTBD = participantOne.countryId === 11;
  const isParticipantTwoTBD = participantTwo.countryId === 11;
  const areBothTBD = isParticipantOneTBD && isParticipantTwoTBD;

  return (
    <div className={`team-event-results${areBothTBD ? ' no-flags' : ''}`}>
      <div className='team-match-container'>
        <div className='team-info'>
          {!areBothTBD && (
            <>
              <span className='team-flag'>
                <FlagIcon
                  isoCode={
                    isParticipantOneTBD ? '' : getIsoCodeByCountryId(participantOne.countryId)
                  }
                />
              </span>
              <span className={`team-name${isParticipantOneTBD ? ' tbd' : ''}`}>
                {isParticipantOneTBD ? 'Ilmoitetaan myöhemmin' : participantOne.teamName}
              </span>
            </>
          )}
        </div>
        {children}
        <div className='team-info'>
          {!areBothTBD && (
            <>
              <span className='team-flag'>
                <FlagIcon
                  isoCode={
                    isParticipantTwoTBD ? '' : getIsoCodeByCountryId(participantTwo.countryId)
                  }
                />
              </span>
              <span className={`team-name${isParticipantTwoTBD ? ' tbd' : ''}`}>
                {isParticipantTwoTBD ? 'Ilmoitetaan myöhemmin' : participantTwo.teamName}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
